/* A4 — Integrações globais (Painel Administrativo).
 *
 * As APIs que valem para toda a plataforma ou como padrão. Ligada ao real
 * `/api/assistants` para derivar o estado do que já existe (chave OpenAI por
 * empresa; servidores Evolution em uso).
 *
 * Editar essas configurações no painel (ElevenLabs sair do ambiente, chave
 * OpenAI padrão) é Fase 0 — hoje a tela mostra o estado e marca a nota. */

import React from 'react';

import { api } from '../api/cliente';
import { useRecurso } from '../estado/recurso';
import { Aviso, card, Cabecalho, Icon, Nota, Secao, Tag } from './ui';

function host(url) {
  try {
    return new URL(url).hostname;
  } catch {
    return url || '—';
  }
}

function Bloco({ icone, titulo, descricao, tag, children }) {
  return (
    <div style={{ ...card, padding: 20, gap: 14 }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12 }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 38, borderRadius: 'var(--radius-md)', background: 'var(--surface-raised)', color: 'var(--text-brand)' }}>
            <Icon name={icone} size={19} />
          </span>
          <span style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ font: 'var(--type-title)' }}>{titulo}</span>
            <span style={{ font: 'var(--type-caption)', color: 'var(--text-muted)' }}>{descricao}</span>
          </span>
        </span>
        {tag}
      </div>
      {children}
    </div>
  );
}

export default function Integracoes() {
  const recurso = useRecurso((sinal) => api.assistentes(sinal), []);
  const itens = recurso.dados?.itens || [];
  const comOpenai = itens.filter((a) => a.chaves?.openai).length;
  const servidores = new Set(itens.map((a) => host(a.evoapi_url))).size;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, overflow: 'hidden' }}>
      <Cabecalho titulo="Integrações" descricao="As APIs globais da plataforma e os padrões que cada empresa herda." />

      <div style={{ flex: 1, minHeight: 0, overflow: 'auto', padding: '0 24px 8px' }}>
        {recurso.erro ? (
          <Secao><Aviso titulo="As integrações não carregaram" texto={recurso.erro.mensagem} acao={recurso.erro.temporario ? 'Tentar de novo' : null} aoAcao={recurso.recarregar} /></Secao>
        ) : (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))', gap: 16 }}>
              <Bloco icone="audio-lines" titulo="ElevenLabs (voz)" descricao="Chave única, vale para todos os clientes" tag={<Tag tone="neutral">Global · via ambiente</Tag>}>
                <span style={{ font: 'var(--type-caption)', color: 'var(--text-placeholder)' }}>Editar voz e parâmetros no painel chega na Fase 0. Hoje vem das variáveis de ambiente.</span>
              </Bloco>

              <Bloco icone="cpu" titulo="OpenAI" descricao="Chave padrão + override por empresa" tag={<Tag tone={comOpenai ? 'success' : 'warning'}>{comOpenai} de {itens.length} configuradas</Tag>}>
                <span style={{ font: 'var(--type-caption)', color: 'var(--text-placeholder)' }}>Chave padrão da plataforma e sobrescrita por empresa. A chave por empresa já vive em Empresas.</span>
              </Bloco>

              <Bloco icone="server" titulo="Evolution" descricao="Camada de WhatsApp" tag={<Tag tone="info">{servidores} {servidores === 1 ? 'servidor' : 'servidores'}</Tag>}>
                <span style={{ font: 'var(--type-caption)', color: 'var(--text-muted)' }}>Gerenciado na aba Servidores.</span>
              </Bloco>
            </div>
            <Nota>Configuração global editável (chaves write-only no painel) é Fase 0. Esta tela mostra o estado do que já existe.</Nota>
          </>
        )}
      </div>
    </div>
  );
}
